import { TOKEN_STORAGE_USER_KEY } from 'auth/domain/User'
import { getStoredUser } from 'auth/infra/StoredUser'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

// The values for token and user are only retrieved once when this hook mounts
// We should probably update this when the token or user are updated
// But that's a big refactor on how we store the token and user
export function useSession() {
  const storage = new LocalStorageClient()

  const token = storage.get<string>(TOKEN_STORAGE_USER_KEY)
  const user = getStoredUser(storage)

  if (!token || !user) {
    return null
  }

  return { token, user }
}
